/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.commentModule')
.directive('bulbCommentUser', bulbCommentUser);

function bulbCommentUser() {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/comment/comment-user.html',
    scope: {
      commentUnit: '=',
      sideComment: '='
    }
  };
}
